<template>
  <div>
    <!-- 標頭 + 日期篩選區 -->
    <div class="content-8__titlebar">
      <div class="content-8__titlebar__left">
        <div class="c8-titlename">
          <span class="c8-titlename__text">开奖号码</span>
        </div>
        <div class="c8-menubox">
          <div class="c8-menubox__btnbox">
            <a
              v-for="(tabItem, index) in tabbarItmes"
              :key="`tab-${index}`"
              class="button-outline c8-menubox__btnbox__item"
              :class="{ 'active': componentName === tabItem.val }"
              href=""
              @click.prevent="componentName = tabItem.val"
            >
              <span class="button-outline__text">{{ tabItem.name }}</span>
            </a>
          </div>
        </div>
      </div>
      <div class="content-8__titlebar__right">
        <YearPicker
          v-if="isHK"
          v-model="selectDate"
        />
        <DateFilterTab v-else v-model="selectDate" />
      </div>
    </div>

    <transition name="layout" mode="out-in">
      <NoData v-if="tableData.length === 0 && !isLoading" />
      <component :is="componentName" v-else :key="componentName" v-loading="isLoading" :table-data="tableData" />
    </transition>

  </div>
</template>

<script>
import { getHistoryData } from '@/api/desktop/tongJi'
import { ruleCodeMapping } from '@/utils/newRuleCodeMapping-Sean'

import YearPicker from '@/components/desktop/common/YearPicker'
import NoData from '@/components/desktop/common/NoData'
import DateFilterTab from '@/components/desktop/common/DateFilterTab'
import HaoMaZhuShou from '@/components/desktop/pages/trend/KaiJiangHaoMa/HaoMaZhuShou'
import ZhengMaFenXi from '@/components/desktop/pages/trend/KaiJiangHaoMa/ZhengMaFenXi'
import TeMaFenXi from '@/components/desktop/pages/trend/KaiJiangHaoMa/TeMaFenXi'
import ShengXiaoFenXi from '@/components/desktop/pages/trend/KaiJiangHaoMa/ShengXiaoFenXi'

export default {
  name: 'KaiJiangHaoMa',
  components: {
    DateFilterTab,
    YearPicker,
    NoData,
    HaoMaZhuShou,
    ZhengMaFenXi,
    TeMaFenXi,
    ShengXiaoFenXi
  },
  data() {
    return {
      ruleCodeMapping: { ...ruleCodeMapping },
      tableData: [],
      selectDate: '30',
      isLoading: false,
      componentName: 'HaoMaZhuShou',
      tabbarItmes: [
        { name: '号码助手', val: 'HaoMaZhuShou' },
        { name: '正码分析', val: 'ZhengMaFenXi' },
        { name: '特码分析', val: 'TeMaFenXi' },
        { name: '生肖分析', val: 'ShengXiaoFenXi' }
      ]
    }
  },
  computed: {
    isHK() {
      return this.$route.params.lottery_code === 'hk6'
    },
    // 根據選擇的屬性展示對應的篩選條件
    filterConditions() {
      switch (this.selectFilterProperty) {
        case 'shengXiao':
          return [
            { name: '鼠', val: 'shengXiao_shu' },
            { name: '牛', val: 'shengXiao_niou' },
            { name: '虎', val: 'shengXiao_hu' },
            { name: '兔', val: 'shengXiao_tu' },
            { name: '龙', val: 'shengXiao_long' },
            { name: '蛇', val: 'shengXiao_she' },
            { name: '马', val: 'shengXiao_ma' },
            { name: '羊', val: 'shengXiao_yang' },
            { name: '猴', val: 'shengXiao_hou' },
            { name: '鸡', val: 'shengXiao_ji' },
            { name: '狗', val: 'shengXiao_gou' },
            { name: '猪', val: 'shengXiao_jhu' }
          ]
        case 'wuXing':
          return [
            { name: '金', val: 'wuXing_jin' },
            { name: '木', val: 'wuXing_mu' },
            { name: '水', val: 'wuXing_shuei' },
            { name: '火', val: 'wuXing_huo' },
            { name: '土', val: 'wuXing_tu' }
          ]
        case 'shengXiaoDongWu':
          return [
            { name: '家禽', val: 'dongWu_jiaChin' },
            { name: '野兽', val: 'dongWu_yehShou' }
          ]
        case 'shengXiaoNanNyu':
          return [
            { name: '男肖', val: 'nanNyu_nan' },
            { name: '女肖', val: 'nanNyu_nyu' }
          ]
        case 'shengXiaoTianDi':
          return [
            { name: '天肖', val: 'tianDi_tian' },
            { name: '地肖', val: 'tianDi_di' }
          ]
        case 'shengXiaoSihJi':
          return [
            { name: '春肖', val: 'sihJi_chun' },
            { name: '夏肖', val: 'sihJi_sia' },
            { name: '秋肖', val: 'sihJi_chiou' },
            { name: '冬肖', val: 'sihJi_dong' }
          ]
        case 'shengXiaoSihYi':
          return [
            { name: '琴肖', val: 'sihYi_chin' },
            { name: '棋肖', val: 'sihYi_chi' },
            { name: '书肖', val: 'sihYi_shu' },
            { name: '画肖', val: 'sihYi_hua' }
          ]
        case 'shengXiaoYanSe':
          return [
            { name: '红肖', val: 'yanse_hong' },
            { name: '蓝肖', val: 'yanse_lan' },
            { name: '绿肖', val: 'yanse_lyu' }
          ]
        default:
          console.warn('匹配不到 filterConditions 請檢查 filterProperty')
          return []
      }
    }
  },
  watch: {
    selectDate(newValue) {
      this.getData(newValue)
    }
  },
  mounted() {
    if (this.isHK) {
      this.selectDate = `${new Date().getFullYear()}`
      this.getData(this.selectDate)
    } else {
      this.getData('30')
    }
  },
  methods: {
    getTableList() {
      this.getData(this.selectDate)
    },
    async getData(query) {
      this.isLoading = true
      const queryObj = {}
      // 期數 count
      if (/^\d{2}$/.test(query)) {
        queryObj.count = query
      } else if (/^\d{4}$/.test(query)) {
        // 香港六合 year
        queryObj.year = query
      } else {
        // 一般 date
        queryObj.date = query
      }
      const [data, error] = await getHistoryData(
        this.$route.params.lottery_code,
        {
          ...queryObj
        }
      )
      this.isLoading = false
      if (error) {
        console.error(`[error]:`, error)
        return
      }
      this.tableData = data
    }
  }
}
</script>
<style lang="scss" scoped>

</style>
